export default __webpack_public_path__ + "static/media/detail_big_15_7.d0680466.jpg";